// Type imports:
import { IPrivateGeniumInetTradeReport, IPrivateInetTradeReport, IPrivateOrder, IPrivateTrade, } from '../api/PrivateTypes';

/* REQUEST PRIVATE ORDERS AND TRADES */
export const REQUEST_PRIVATE_ORDERS_AND_TRADES_WAITING = 'REQUEST_PRIVATE_ORDERS_AND_TRADES_WAITING';
export const REQUEST_PRIVATE_ORDERS_AND_TRADES_SUCCESS = 'REQUEST_PRIVATE_ORDERS_AND_TRADES_SUCCESS';
export const REQUEST_PRIVATE_ORDERS_AND_TRADES_FAILURE = 'REQUEST_PRIVATE_ORDERS_AND_TRADES_FAILURE';

interface IRequestPrivateOrdersAndTradesWaitingAction {
    type: typeof REQUEST_PRIVATE_ORDERS_AND_TRADES_WAITING,
    payload: {
        symbol: string,
        tradingDay: string
    }
}

interface IRequestPrivateOrdersAndTradesSuccessAction {
    type: typeof REQUEST_PRIVATE_ORDERS_AND_TRADES_SUCCESS,
    payload: {
        symbol: string,
        tradingDay: string,
        orders: IPrivateOrder[],
        trades: IPrivateTrade[],
        inetTradeReports: IPrivateInetTradeReport[],
        geniumInetTradeReports: IPrivateGeniumInetTradeReport[]
    }
}

interface IRequestPrivateOrdersAndTradesFailureAction {
    type: typeof REQUEST_PRIVATE_ORDERS_AND_TRADES_FAILURE,
    payload: {
        symbol: string,
        tradingDay: string,
        error: string,
    }
}

/* CLEAR FAILOVER */
export const CLEAR_FAILOVER = 'CLEAR_FAILOVER';
interface IClearFailoverAction {
    type: typeof CLEAR_FAILOVER
}

/* EXPORT */
export type PrivateActions =
// Request private orders.
IRequestPrivateOrdersAndTradesWaitingAction
| IRequestPrivateOrdersAndTradesSuccessAction
| IRequestPrivateOrdersAndTradesFailureAction
// Clear failover.
| IClearFailoverAction;